import { render, staticRenderFns } from "./ActiveList.vue?vue&type=template&id=9040c6fa&scoped=true"
import script from "./ActiveList.vue?vue&type=script&lang=js"
export * from "./ActiveList.vue?vue&type=script&lang=js"
import style0 from "./ActiveList.vue?vue&type=style&index=0&id=9040c6fa&prod&lang=scss&scoped=true"
import style1 from "./ActiveList.vue?vue&type=style&index=1&id=9040c6fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9040c6fa",
  null
  
)

export default component.exports